module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/map-anno-42.c6d6495f8c09cd94.png"+" 42w",
        images: [{path: "https://static.sniffspot.com/packs/img/map-anno-42.c6d6495f8c09cd94.png",width: 42,height: 50}],
        src: "https://static.sniffspot.com/packs/img/map-anno-42.c6d6495f8c09cd94.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/map-anno-42.c6d6495f8c09cd94.png"},
        
        width: 42,
        height: 50
      }